module.exports = __webpack_public_path__ + "static/media/Location_Book-Page3.acf48cce.png";